import React, { useState, useEffect, useRef } from "react";
import { V2Button } from "@abyss/web/ui/Button";
import { IconSymbol } from "@abyss/web/ui/IconSymbol";
import { V2Link } from "@abyss/web/ui/Link";

import styles from "./floatingchat.module.css";

import classNames from "classnames";
import { PlanDetail } from "../PlanDetail";
import { VoteButtons } from "./VoteButtons";

const dataQuestions = [
  {
    id: "1",
    content: `<span>Which plan has the lower monthly premium?</span>`,
  },
  {
    id: "2",
    content: `<span>Which plan has the lower copay to visit my primary care doctor?</span>`,
  },
  {
    id: "3",
    content: `<span>Do these plans offer vision and dental benefits?</span>`,
  },
];

const dataResponses = [
  {
    id: "1",
    content: `
      <div>
        The lowest monthly premium is $0 for several plans:
        <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
          <li>
          <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage from UHC MN-0001 (PPO)</span>: $0 In-network, but you must pay your Medicare Part B premium.
          </li>
          <li>
          <span style="color: #196ecf; font-weight: 700;">UHC Complete Care MN-7 (PPO C-SNP)</span>: $0 In-network, Medicare Part B premium required.
          </li>
          <li>
          <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage Patriot No Rx FG-MA01 (PPO)</span>: $0 In-network, with up to $125 Part B premium reduction.
          </li>
        </ul>
All other plans have higher monthly premiums. Let me know if you want details on other costs or benefits.
      </div>
    `,
  },
  {
    id: "2",
    content: `<div>
        All of the listed plans except the <span style="color: #196ecf; font-weight: 700;">UHC Nursing Home Plan MN-F001 (PPO I-SNP)</span> have a $0 copay for in-network and out-of-network primary care visits.
        <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
          <li>
          <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage from UHC MN-0005 (PPO)</span>, MN-0001 (PPO), MN-0002 (PPO), FG-0001 (PPO), <span style="color: #196ecf; font-weight: 700;">UHC Complete Care MN-7 (PPO C-SNP)</span>, <span style="color: #196ecf; font-weight: 700;">UHC Complete Care Support MN-8 (PPO C-SNP)</span>, and <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage Patriot No Rx FG-MA01 (PPO)</span>: $0 In-network and $0 Out-of-network
          </li>
          <li>
          <span style="color: #196ecf; font-weight: 700;">UHC Nursing Home Plan MN-F001 (PPO I-SNP)</span>: $0 In-network; 30% Out-of-network
          </li>
        </ul>
      </div>`,
  },
  {
    id: "3",
    content: `<div>
      Yes, all these plans offer vision and dental benefits.
      <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
          <li>
            <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage from UHC MN-0005 (PPO)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for routine vision exams and eyewear; $2,000 dental annual max.</li>
              <li>Dental covers preventive, diagnostic, and major services; no optional dental rider.</li>
            </ul>          
          </li>
          <li>
            <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage from UHC MN-0001 (PPO)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for vision exams; $300 eyewear allowance; $1,000 dental annual max.</li>
              <li>Dental covers preventive, diagnostic, and major services; no optional dental rider.</li>
            </ul>          
          </li>
          <li>
            <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage from UHC MN-0002 (PPO)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for vision exams; $200 eyewear allowance; dental covers preventive and major services.</li>
              <li>No optional dental rider mentioned.</li>
            </ul>          
          </li>
          <li>
            <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage from UHC FG-0001 (PPO)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for vision exams; $200 eyewear allowance; dental coverage may be available, especially out-of-network.</li>
              <li>No optional dental rider mentioned.</li>
            </ul>          
          </li>
          <li>
            <span style="color: #196ecf; font-weight: 700;">AARP Medicare Advantage Patriot No Rx FG-MA01 (PPO)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for vision exams; $250 eyewear allowance; dental benefits available, including out-of-network.</li>
              <li>No optional dental rider mentioned.</li>
            </ul>          
          </li>
          <li>
            <span style="color: #196ecf; font-weight: 700;">UHC Complete Care MN-7 (PPO C-SNP)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for vision exams; $250 eyewear allowance; routine dental and optional Platinum Dental Rider available.</li>
              <li>Platinum Dental Rider offers extra comprehensive dental coverage for $54/month.</li>
            </ul>          
          </li>
          <li>
            <span style="color: #196ecf; font-weight: 700;">UHC Complete Care Support MN-8 (PPO C-SNP)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for vision exams; $300 eyewear allowance; $1,000 dental allowance for covered services.</li>
              <li>No optional dental rider mentioned.</li>
            </ul>          
          </li>
           <li>
            <span style="color: #196ecf; font-weight: 700;">UHC Nursing Home Plan MN-F001 (PPO I-SNP)</span>:
            <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
              <li>$0 copay for vision exams; $300 eyewear allowance; $3,250 dental annual max.</li>
              <li>Dental covers preventive, diagnostic, and major services; no optional dental rider mentioned.</li>
            </ul>          
          </li>
        </ul>
      </div>`,
  },
];

export const FloatingChatSummary = () => {
  const [chatVisible, setChatVisible] = useState(true);
  const [chatSelected, setChatSelected] = useState("all");
  const [response, setResponse] = useState([]);

  const containerRef = useRef(null);
  const loadingRefs = useRef([]);
  const answerRefs = useRef([]);

  const toggleChatWindow = () => {
    setChatVisible(!chatVisible);
  };

  const showAnswer = (number) => {
    setChatSelected(number);

    const foundQuestion = dataQuestions?.find(
      (item) => item?.id === number
    )?.content;
    const foundAnswer = dataResponses?.find(
      (item) => item?.id === number
    )?.content;

    setResponse([
      ...response,
      { question: foundQuestion, answer: foundAnswer },
    ]);
  };

  const typedAnswer = (e) => {
    e.preventDefault();

    setChatSelected("typed");

    setResponse([
      ...response,
      {
        question: e.target[0].value,
        answer:
          "<div>I can answer questions about Medicare Advantage plans. For more coverage information, please refer to the source documents below.</div>",
      },
    ]);

    e.target[0].value = "";
  };

  return (
    <React.Fragment>
      <div className={styles.planCompareImage}>
        <img src="./assets/images/plansummary.png" />
      </div>
      <div className={styles.samButtons}>
        <div>
          <button onClick={toggleChatWindow}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16.7075 13.6986C13.1142 13.6986 10.1995 10.7839 10.1995 7.19062C10.1995 7.08862 10.1171 7.00232 10.0112 7.00232C9.90527 7.00232 9.82289 7.0847 9.82289 7.19062C9.82289 10.7839 6.90821 13.6986 3.31488 13.6986C3.21289 13.6986 3.12659 13.781 3.12659 13.8869C3.12659 13.9928 3.20897 14.0752 3.31488 14.0752C6.90821 14.0752 9.82289 16.9899 9.82289 20.5832C9.82289 20.6852 9.90527 20.7715 10.0112 20.7715C10.1171 20.7715 10.1995 20.6891 10.1995 20.5832C10.1995 16.9899 13.1142 14.0752 16.7075 14.0752C16.8095 14.0752 16.8958 13.9928 16.8958 13.8869C16.8958 13.781 16.8134 13.6986 16.7075 13.6986Z"
                fill="white"
              />
              <path
                d="M20.0536 7.04152C18.2884 7.04152 16.8565 5.60968 16.8565 3.84439C16.8565 3.7934 16.8134 3.75024 16.7624 3.75024C16.7114 3.75024 16.6682 3.7934 16.6682 3.84439C16.6682 5.60968 15.2364 7.04152 13.4711 7.04152C13.4201 7.04152 13.377 7.08467 13.377 7.13566C13.377 7.18666 13.4201 7.22981 13.4711 7.22981C15.2364 7.22981 16.6682 8.66165 16.6682 10.4269C16.6682 10.4779 16.7114 10.5211 16.7624 10.5211C16.8134 10.5211 16.8565 10.4779 16.8565 10.4269C16.8565 8.66165 18.2884 7.22981 20.0536 7.22981C20.1046 7.22981 20.1478 7.18666 20.1478 7.13566C20.1478 7.08467 20.1046 7.04152 20.0536 7.04152Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div>
          <button>
            <IconSymbol
              icon="chat"
              color="white"
              size="24px"
              variant="outlined"
            />
          </button>
        </div>
        <div>
          <button>
            <IconSymbol
              icon="phone"
              color="white"
              size="24px"
              variant="outlined"
            />
          </button>
        </div>
      </div>
      <div>
        <div
          className={classNames(
            styles.floatbox,
            chatVisible ? styles.isVisible : ""
          )}
        >
          <div className={styles.floatboxInner}>
            <div className={styles.floatboxHd}>
              <div className={styles.floatboxHdUpper}>
                <div className={styles.floatboxTitle}>
                  Do you have questions?
                </div>
                <div className={styles.floatboxClose}>
                  <div
                    className={styles.chatboxClose}
                    onClick={() => {
                      setChatVisible(false);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="39"
                      viewBox="0 0 39 39"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_6993_30597)">
                        <path
                          d="M27 13.5107L25.4893 12L19.5 17.9893L13.5107 12L12 13.5107L17.9893 19.5L12 25.4893L13.5107 27L19.5 21.0107L25.4893 27L27 25.4893L21.0107 19.5L27 13.5107Z"
                          fill="#196ECF"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6993_30597">
                          <rect width="38.75" height="38.75" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.floatboxBd}>
              {chatSelected === "all" && (
                <div className={styles.floatboxItems}>
                  <div
                    className={styles.floatQuestion}
                    onClick={() => showAnswer("1")}
                  >
                    <div className={styles.floatQuestionIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                      >
                        <path
                          d="M7.5 15.75H13.5C13.7833 15.75 14.0208 15.6542 14.2125 15.4625C14.4042 15.2708 14.5 15.0333 14.5 14.75C14.5 14.4667 14.4042 14.2292 14.2125 14.0375C14.0208 13.8458 13.7833 13.75 13.5 13.75H7.5C7.21667 13.75 6.97917 13.8458 6.7875 14.0375C6.59583 14.2292 6.5 14.4667 6.5 14.75C6.5 15.0333 6.59583 15.2708 6.7875 15.4625C6.97917 15.6542 7.21667 15.75 7.5 15.75ZM7.5 12.75H17.5C17.7833 12.75 18.0208 12.6542 18.2125 12.4625C18.4042 12.2708 18.5 12.0333 18.5 11.75C18.5 11.4667 18.4042 11.2292 18.2125 11.0375C18.0208 10.8458 17.7833 10.75 17.5 10.75H7.5C7.21667 10.75 6.97917 10.8458 6.7875 11.0375C6.59583 11.2292 6.5 11.4667 6.5 11.75C6.5 12.0333 6.59583 12.2708 6.7875 12.4625C6.97917 12.6542 7.21667 12.75 7.5 12.75ZM7.5 9.75H17.5C17.7833 9.75 18.0208 9.65417 18.2125 9.4625C18.4042 9.27083 18.5 9.03333 18.5 8.75C18.5 8.46667 18.4042 8.22917 18.2125 8.0375C18.0208 7.84583 17.7833 7.75 17.5 7.75H7.5C7.21667 7.75 6.97917 7.84583 6.7875 8.0375C6.59583 8.22917 6.5 8.46667 6.5 8.75C6.5 9.03333 6.59583 9.27083 6.7875 9.4625C6.97917 9.65417 7.21667 9.75 7.5 9.75ZM6.5 19.75L4.2 22.05C3.88333 22.3667 3.52083 22.4375 3.1125 22.2625C2.70417 22.0875 2.5 21.775 2.5 21.325V5.75C2.5 5.2 2.69583 4.72917 3.0875 4.3375C3.47917 3.94583 3.95 3.75 4.5 3.75H20.5C21.05 3.75 21.5208 3.94583 21.9125 4.3375C22.3042 4.72917 22.5 5.2 22.5 5.75V17.75C22.5 18.3 22.3042 18.7708 21.9125 19.1625C21.5208 19.5542 21.05 19.75 20.5 19.75H6.5ZM5.65 17.75H20.5V5.75H4.5V18.875L5.65 17.75Z"
                          fill="#002677"
                        />
                      </svg>
                    </div>
                    <div className={styles.floatQuestionCopy}>
                      Which plan has the lower monthly premium?
                    </div>
                  </div>
                  <div
                    className={styles.floatQuestion}
                    onClick={() => showAnswer("2")}
                  >
                    <div className={styles.floatQuestionIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                      >
                        <path
                          d="M7.5 15.75H13.5C13.7833 15.75 14.0208 15.6542 14.2125 15.4625C14.4042 15.2708 14.5 15.0333 14.5 14.75C14.5 14.4667 14.4042 14.2292 14.2125 14.0375C14.0208 13.8458 13.7833 13.75 13.5 13.75H7.5C7.21667 13.75 6.97917 13.8458 6.7875 14.0375C6.59583 14.2292 6.5 14.4667 6.5 14.75C6.5 15.0333 6.59583 15.2708 6.7875 15.4625C6.97917 15.6542 7.21667 15.75 7.5 15.75ZM7.5 12.75H17.5C17.7833 12.75 18.0208 12.6542 18.2125 12.4625C18.4042 12.2708 18.5 12.0333 18.5 11.75C18.5 11.4667 18.4042 11.2292 18.2125 11.0375C18.0208 10.8458 17.7833 10.75 17.5 10.75H7.5C7.21667 10.75 6.97917 10.8458 6.7875 11.0375C6.59583 11.2292 6.5 11.4667 6.5 11.75C6.5 12.0333 6.59583 12.2708 6.7875 12.4625C6.97917 12.6542 7.21667 12.75 7.5 12.75ZM7.5 9.75H17.5C17.7833 9.75 18.0208 9.65417 18.2125 9.4625C18.4042 9.27083 18.5 9.03333 18.5 8.75C18.5 8.46667 18.4042 8.22917 18.2125 8.0375C18.0208 7.84583 17.7833 7.75 17.5 7.75H7.5C7.21667 7.75 6.97917 7.84583 6.7875 8.0375C6.59583 8.22917 6.5 8.46667 6.5 8.75C6.5 9.03333 6.59583 9.27083 6.7875 9.4625C6.97917 9.65417 7.21667 9.75 7.5 9.75ZM6.5 19.75L4.2 22.05C3.88333 22.3667 3.52083 22.4375 3.1125 22.2625C2.70417 22.0875 2.5 21.775 2.5 21.325V5.75C2.5 5.2 2.69583 4.72917 3.0875 4.3375C3.47917 3.94583 3.95 3.75 4.5 3.75H20.5C21.05 3.75 21.5208 3.94583 21.9125 4.3375C22.3042 4.72917 22.5 5.2 22.5 5.75V17.75C22.5 18.3 22.3042 18.7708 21.9125 19.1625C21.5208 19.5542 21.05 19.75 20.5 19.75H6.5ZM5.65 17.75H20.5V5.75H4.5V18.875L5.65 17.75Z"
                          fill="#002677"
                        />
                      </svg>
                    </div>
                    <div className={styles.floatQuestionCopy}>
                      Which plan has the lower copay to visit my primary care
                      doctor?
                    </div>
                  </div>
                  <div
                    className={styles.floatQuestion}
                    onClick={() => showAnswer("3")}
                  >
                    <div className={styles.floatQuestionIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                      >
                        <path
                          d="M7.5 15.75H13.5C13.7833 15.75 14.0208 15.6542 14.2125 15.4625C14.4042 15.2708 14.5 15.0333 14.5 14.75C14.5 14.4667 14.4042 14.2292 14.2125 14.0375C14.0208 13.8458 13.7833 13.75 13.5 13.75H7.5C7.21667 13.75 6.97917 13.8458 6.7875 14.0375C6.59583 14.2292 6.5 14.4667 6.5 14.75C6.5 15.0333 6.59583 15.2708 6.7875 15.4625C6.97917 15.6542 7.21667 15.75 7.5 15.75ZM7.5 12.75H17.5C17.7833 12.75 18.0208 12.6542 18.2125 12.4625C18.4042 12.2708 18.5 12.0333 18.5 11.75C18.5 11.4667 18.4042 11.2292 18.2125 11.0375C18.0208 10.8458 17.7833 10.75 17.5 10.75H7.5C7.21667 10.75 6.97917 10.8458 6.7875 11.0375C6.59583 11.2292 6.5 11.4667 6.5 11.75C6.5 12.0333 6.59583 12.2708 6.7875 12.4625C6.97917 12.6542 7.21667 12.75 7.5 12.75ZM7.5 9.75H17.5C17.7833 9.75 18.0208 9.65417 18.2125 9.4625C18.4042 9.27083 18.5 9.03333 18.5 8.75C18.5 8.46667 18.4042 8.22917 18.2125 8.0375C18.0208 7.84583 17.7833 7.75 17.5 7.75H7.5C7.21667 7.75 6.97917 7.84583 6.7875 8.0375C6.59583 8.22917 6.5 8.46667 6.5 8.75C6.5 9.03333 6.59583 9.27083 6.7875 9.4625C6.97917 9.65417 7.21667 9.75 7.5 9.75ZM6.5 19.75L4.2 22.05C3.88333 22.3667 3.52083 22.4375 3.1125 22.2625C2.70417 22.0875 2.5 21.775 2.5 21.325V5.75C2.5 5.2 2.69583 4.72917 3.0875 4.3375C3.47917 3.94583 3.95 3.75 4.5 3.75H20.5C21.05 3.75 21.5208 3.94583 21.9125 4.3375C22.3042 4.72917 22.5 5.2 22.5 5.75V17.75C22.5 18.3 22.3042 18.7708 21.9125 19.1625C21.5208 19.5542 21.05 19.75 20.5 19.75H6.5ZM5.65 17.75H20.5V5.75H4.5V18.875L5.65 17.75Z"
                          fill="#002677"
                        />
                      </svg>
                    </div>
                    <div className={styles.floatQuestionCopy}>
                      Do these plans offer vision and dental benefits?
                    </div>
                  </div>
                </div>
              )}

              <div className={styles.responseItems}>
                {response.map((item, index) => (
                  <div key={index}>
                    <div className={styles.questionContain}>
                      <div
                        className={styles.question}
                        dangerouslySetInnerHTML={{ __html: item?.question }}
                      ></div>
                    </div>
                    <div
                      className={styles.snippet}
                      ref={(element) =>
                        (loadingRefs.current[item.id] = element)
                      }
                    >
                      <div className={styles.stage}>
                        <div className={styles.dotTyping}></div>
                      </div>
                    </div>
                    <div
                      className={styles.answerWrap}
                      ref={(element) => (answerRefs.current[item.id] = element)}
                    >
                      <div
                        className={styles.answer}
                        dangerouslySetInnerHTML={{ __html: item?.answer }}
                      ></div>
                      <VoteButtons />
                    </div>
                  </div>
                ))}
              </div>
              <div ref={containerRef}></div>
            </div>
            <div className={styles.floatboxFt}>
              <div className={styles.textInput}>
                <form onSubmit={typedAnswer}>
                  <input type="text" placeholder="Type your question here" />
                  <div className={styles.textInputIcons}>
                    <IconSymbol icon="keyboard_voice" variant="outlined" />
                    <button type="submit">
                      <IconSymbol icon="send" variant="outlined" />
                    </button>
                  </div>
                </form>
              </div>
              {/* <div className={styles.askButton}>
                  <V2Button css={{ width: "100%" }}>
                    <span>Ask the plan companion</span>{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M16.7074 14.4486C13.114 14.4486 10.1994 11.5339 10.1994 7.94062C10.1994 7.83862 10.117 7.75232 10.0111 7.75232C9.90515 7.75232 9.82277 7.8347 9.82277 7.94062C9.82277 11.5339 6.90809 14.4486 3.31476 14.4486C3.21277 14.4486 3.12646 14.531 3.12646 14.6369C3.12646 14.7428 3.20884 14.8252 3.31476 14.8252C6.90809 14.8252 9.82277 17.7399 9.82277 21.3332C9.82277 21.4352 9.90515 21.5215 10.0111 21.5215C10.117 21.5215 10.1994 21.4391 10.1994 21.3332C10.1994 17.7399 13.114 14.8252 16.7074 14.8252C16.8094 14.8252 16.8957 14.7428 16.8957 14.6369C16.8957 14.531 16.8133 14.4486 16.7074 14.4486Z"
                        fill="white"
                      />
                      <path
                        d="M20.0536 7.79152C18.2884 7.79152 16.8565 6.35968 16.8565 4.59439C16.8565 4.5434 16.8134 4.50024 16.7624 4.50024C16.7114 4.50024 16.6682 4.5434 16.6682 4.59439C16.6682 6.35968 15.2364 7.79152 13.4711 7.79152C13.4201 7.79152 13.377 7.83467 13.377 7.88566C13.377 7.93666 13.4201 7.97981 13.4711 7.97981C15.2364 7.97981 16.6682 9.41165 16.6682 11.1769C16.6682 11.2279 16.7114 11.2711 16.7624 11.2711C16.8134 11.2711 16.8565 11.2279 16.8565 11.1769C16.8565 9.41165 18.2884 7.97981 20.0536 7.97981C20.1046 7.97981 20.1478 7.93666 20.1478 7.88566C20.1478 7.83467 20.1046 7.79152 20.0536 7.79152Z"
                        fill="white"
                      />
                    </svg>
                  </V2Button>
                </div> */}
              <div className={styles.agentButton}>
                <V2Link afterIcon="chevron_right" href="#">
                  Chat with a Licensed Agent instead
                </V2Link>
              </div>
              <div className={styles.info}>
                Benefit and coverage answers are generated by AI and may contain
                errors or incomplete information.
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
